import './App.css';
//import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './components/home/Home';
import CV from './components/CV';
import Contact from './components/Contact';
import {
  UserProvider
  //, useUser
} from './providers/UserProvider';
//import SignInOrOut from './components/Profile';
import SchmusiHome from './components/schmusi/SchmusiHome';
import RubyHome from './components/ruby/RubyHome';
import NotAmusedCatHome from './components/notamusedcat/NotAmusedCatHome';
import SchmusisPurrfectPairsHome from './components/schmusi-s-purrfect-pairs/SchmusisPurrfectPairs';
import CharcoalHome from './components/charcoal/CharcoalHome';
import KaminoHome from './components/kamino/KaminoHome';
import Snapfit2Home from './components/snapfit2/Snapfit2Home';
import TeamTypeHome from './components/teamtype/TeamTypeHome';
import NetAlertXCompanionHome from './components/netalertxcompanion/NetAlertXCompanionHome';
import FinansiusHome from './components/finansius/FinansiusHome';
import FriendWheelHome from './components/friend-wheel/FriendWheelHome';
import EggodoroHome from './components/eggodoro/EggodoroHome';
import TestHome from './components/test/TestHome';
import DeeplinkTester from './components/deeplink_tester/DeeplinkTester';
import Test3Home from './components/test3/Test3Home';
import PlainOldTexts from './components/plain_text/PlainOldTexts';
import JsonPrettifier from './components/json_prettifier/JsonPrettifier';
import DiffChecker from './components/diff/DiffChecker';
import IpInfo from './components/ip_info/IpInfo';
import { ThemeProvider } from '@emotion/react';
import theme from './theme';


import { useState, useEffect } from 'react';

const getInitialNight = () => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('nightMode');
    if (stored !== null) return stored === 'true';
    // Detect device preference
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
  return false;
};

function toggleBodyClass(isNight) {
  if (isNight) {
    document.body.classList.add('night');
    document.body.classList.remove('day');
  } else {
    document.body.classList.add('day');
    document.body.classList.remove('night');
  }
}

function App() {
  const [night, setNight] = useState(getInitialNight);

  useEffect(() => {
    toggleBodyClass(night);
    localStorage.setItem('nightMode', night);
    return () => {
      document.body.classList.remove('night', 'day');
    };
  }, [night]);

  return (
    <div className="App">
      {/*<SignInOrOut />*/}
      <Router>
        <Routes>
          <Route path="/" element={<Home night={night} setNight={setNight} />} />
          <Route path="/cv" element={<CV />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/apps/schmusi" element={<SchmusiHome />} />
          <Route path="/apps/charcoal" element={<CharcoalHome />} />
          <Route path="/apps/kamino" element={<KaminoHome />} />
          <Route path="/apps/ruby" element={<RubyHome />} />
          <Route path="/apps/notamusedcat" element={<NotAmusedCatHome />} />
          <Route path="/apps/snapfit2" element={<Snapfit2Home />} />
          <Route path="/apps/schmusi-s-purrfect-pairs" element={<SchmusisPurrfectPairsHome />} />
          <Route path="/apps/teamtype" element={<TeamTypeHome />} />
          <Route path="/apps/netalertxcompanion" element={<NetAlertXCompanionHome />} />
          <Route path="/apps/finansius" element={<FinansiusHome />} />
          <Route path="/apps/friendwheel" element={<FriendWheelHome />} />
          <Route path="/apps/eggodoro" element={<EggodoroHome />} />
          <Route path="/apps/test" element={<TestHome />} />
          <Route path="/apps/deeplink" element={<DeeplinkTester night={night} setNight={setNight} />} />
          <Route path="/apps/test3" element={<Test3Home />} />
          <Route path="/apps/plain-text" element={<PlainOldTexts night={night} setNight={setNight} />} />
          <Route path="/apps/json-prettifier" element={<JsonPrettifier night={night} setNight={setNight} />} />
          <Route path="/apps/diff" element={<DiffChecker night={night} setNight={setNight} />} />
          <Route path="/apps/ip" element={<IpInfo night={night} />} />
        </Routes>
        {/*<Footer />*/}
      </Router>
    </div>
  );
}

function Root() {
  return (
    <ThemeProvider theme={theme}>
      <UserProvider>
        <App />
      </UserProvider>
    </ThemeProvider>
  );
}

export default Root;
